export default __webpack_public_path__ + "static/media/Nunito-Regular.fd0c54f3.ttf";